import type { useSingleton } from "@tippyjs/react";
import { canv } from "@/canv/global";
import { MultiplayerCursorsIcon } from "@/icons";
import { BottomBarItem } from "@/interface/BottomBar/BottomRightBar";
import { Tooltip } from "@/interface/ui/Tooltip";

type Props = {
    singletoneTarget: ReturnType<typeof useSingleton>[1];
    disableMultiCursors: boolean;
    className?: string;
};

export const MultiplayerCursors = ({ singletoneTarget, disableMultiCursors, className }: Props) => {
    const setDisableMultiCursors = () =>
        canv.multiManager.setDisableMultiCursors(!disableMultiCursors);
    return (
        <Tooltip
            singleton={singletoneTarget}
            content={disableMultiCursors ? "Показать курсоры" : "Скрыть курсоры"}
        >
            <BottomBarItem
                className={className}
                active={!disableMultiCursors}
                onClick={setDisableMultiCursors}
            >
                <MultiplayerCursorsIcon />
            </BottomBarItem>
        </Tooltip>
    );
};
